export const ADD_REFERRAL_START = 'ADD_REFERRAL_START';
export const ADD_REFERRAL_SUCCESS = 'ADD_REFERRAL_SUCCESS';
export const ADD_REFERRAL_ERROR = 'ADD_REFERRAL_ERROR';
